module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_1.4d6def6f.jpg";